/* eslint-disable camelcase */
import * as _ from 'lodash';
import { base_url } from '../config/apiConfig';

export const fetchRegions = (oracleEmployee) => fetch(
  `${base_url}/region?oracleEmployee=${oracleEmployee}`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchEmailToken = (emailToken) => fetch(
  `${base_url}/email/verifyEmail?token=${emailToken}`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchAssociatedAccounts = (email) => fetch(
  `${base_url}/sendAssociatedAccountsByEmail?email=${email}`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchBanner = () => fetch(
  `${base_url}/banner`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchValidateAccount = (body) => fetch(
  `${base_url}/validateAccountName`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchValidateAccountRecursively = (body) => fetch(
  `${base_url}/validateAccountName`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchSecurityLink = (body) => fetch(
  `${base_url}/email/sendSecurityLink`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchCaptchaToken = (body) => fetch(
  `${base_url}/verifyCaptchaToken`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchPromotionGuests = (email, token) => fetch(
  `${base_url}/promotionGuests?email=${email}&captchaJwtToken=${token}`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchValidateEmail = (body) => fetch(
  `${base_url}/validateEmail`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchStateId = (country) => fetch(
  `${base_url}/states?countryId=${country}`,
  {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchPaymentsByEmail = (email, body) => fetch(
  `${base_url}/payments?email=${email}`,
  {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchCreateAccount = (email, body) => fetch(
  `${base_url}/createAccount?email=${email}&language=en`,
  {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body,
  },
);

export const fetchPollLocationUrl = (operationId, programType) => fetch(
  `${base_url}/pollLocationUrl/${operationId}${_.toUpper(programType) === 'MYSQLDSAWS' ? '?programType=MYSQLDSAWS' : ''}`,
  {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  },
);

export const fetchAccountStatusByWorkRequest = (requestId, programType, region) => fetch(
  `${base_url}/accountStatus?workRequestId=${requestId}&region=${region}${_.toUpper(programType) === 'MYSQLDSAWS' ? '&programType=MYSQLDSAWS' : ''}`,
  {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  },
);
